module.exports = __webpack_public_path__ + "img/logo_white.c5e70c1c.png";